<template>
  <div class="wrapper">
    <div class="form-group">
      <label>Export-Type</label>
      <select class="form-control" v-model="config.exporttype">
        <option value="text">Text</option>
        <option value="xls">Excel</option>
        <option value="json">Plain JSON</option>
      </select>
    </div>
    <div class="form-group">
      <label>Ausgabe:</label>
      <input type="text" class="form-control" v-model="config.exportoutput"/>
    </div>
    <div class="form-group" v-show="config.exporttype !== 'json'">
      <label>Template:</label>
      <input type="text" class="form-control" v-model="config.exporttemplate"/>
    </div>
    <div v-if="config.exporttype=='xls'" class="form-group">
      <label>Tabelle</label>
      <input type="text" class="form-control" v-model="config.exportsheet"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExportConfigWidget',
  props: ["config"],
  methods: {

  }
}
</script>
